import { useEffect } from 'react';

/**
 * The tab title every page shares: "DRM WRAP", plus the environment outside production.
 * Same environment rule as App.tsx's Layout, which sets this once on load.
 */
export function baseDocumentTitle(): string {
  const env = (process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || 'development').toLowerCase();
  const valid = ['development', 'staging', 'training', 'testing', 'production'];
  const stage = valid.includes(env) ? env : 'development';
  return stage === 'production' ? 'DRM WRAP' : `DRM WRAP - ${stage.charAt(0).toUpperCase()}${stage.slice(1)}`;
}

/**
 * Per-page tab title ("Vendor Approvals – DRM WRAP"). Restores the previous title on unmount
 * so a page without this hook does not inherit the last page's name.
 */
export function useDocumentTitle(title: string | null | undefined): void {
  useEffect(() => {
    if (!title) return;
    const previous = document.title;
    document.title = `${title} – ${baseDocumentTitle()}`;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
